// import React, { useEffect, useState } from "react";
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   TablePagination, Paper, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, Typography
// } from "@mui/material";

// const DisplayExplanations = () => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [openDetails, setOpenDetails] = useState(false);
//   const [openEdit, setOpenEdit] = useState(false);
//   const [openDelete, setOpenDelete] = useState(false);

//   const [selected, setSelected] = useState(null);
//   const [formData, setFormData] = useState({});

//   // ================= FETCH =================
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const res = await fetch(`${API_URL}/v1/explanations`);
//       const result = await res.json();
//       setData(result.data || []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//     }
//   };

//   // ================= PAGINATION =================
//   const handlePageChange = (_, newPage) => setPage(newPage);

//   const handleRowsChange = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   // ================= DIALOGS =================
//   const openDetailsDialog = (row) => {
//     setSelected(row);
//     setOpenDetails(true);
//   };

//   const openEditDialog = (row) => {
//     setSelected(row);
//     setFormData({
//       verseId: row.verseId,
//       reference: row.reference,
//       explanation: row.explanation,
//       model: row.model,
//     });
//     setOpenEdit(true);
//   };

//   const openDeleteDialog = (row) => {
//     setSelected(row);
//     setOpenDelete(true);
//   };

//   const closeDialogs = () => {
//     setOpenDetails(false);
//     setOpenEdit(false);
//     setOpenDelete(false);
//     setSelected(null);
//     setFormData({});
//   };

//   // ================= INPUT =================
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // ================= UPDATE (UPSERT) =================
//   const handleUpdate = async () => {
//     try {
//       const res = await fetch(`${API_URL}/v1/explanations`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       if (res.ok) {
//         fetchData();
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       closeDialogs();
//     }
//   };

//   // ================= DELETE =================
//   const handleDelete = async () => {
//     try {
//       await fetch(`${API_URL}/v1/explanations/${encodeURIComponent(selected.verseId)}`, {
//         method: "DELETE",
//       });

//       setData((prev) =>
//         prev.filter((d) => d.verseId !== selected.verseId)
//       );
//     } catch (err) {
//       console.error(err);
//     } finally {
//       closeDialogs();
//     }
//   };

//   return (
//     <>
//       {/* ================= TABLE ================= */}
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Verse ID</TableCell>
//               <TableCell>Reference</TableCell>
//               <TableCell>Model</TableCell>
//               <TableCell>Created</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {data
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((row) => (
//                 <TableRow key={row.verseId}>
//                   <TableCell>{row.verseId}</TableCell>
//                   <TableCell>{row.reference}</TableCell>
//                   <TableCell>{row.model}</TableCell>
//                   <TableCell>{row.created_at}</TableCell>

//                   <TableCell sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//                     <Button size="small" onClick={() => openEditDialog(row)}>Edit</Button>
//                     <Button size="small" color="error" onClick={() => openDeleteDialog(row)}>Delete</Button>
//                     <Button size="small" variant="outlined" onClick={() => openDetailsDialog(row)}>View</Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={data.length}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={handlePageChange}
//           onRowsPerPageChange={handleRowsChange}
//         />
//       </TableContainer>

//       {/* ================= DETAILS ================= */}
//       <Dialog open={openDetails} onClose={closeDialogs}>
//         <DialogTitle>Explanation Details</DialogTitle>
//         <DialogContent>
//           <Typography><b>Verse:</b> {selected?.verseId}</Typography>
//           <Typography><b>Reference:</b> {selected?.reference}</Typography>
//           <Typography><b>Explanation:</b> {selected?.explanation}</Typography>
//           <Typography><b>Model:</b> {selected?.model}</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeDialogs}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= EDIT ================= */}
//       <Dialog open={openEdit} onClose={closeDialogs}>
//         <DialogTitle>Edit Explanation</DialogTitle>
//         <DialogContent>

//           <TextField
//             label="Verse ID"
//             name="verseId"
//             value={formData.verseId || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Reference"
//             name="reference"
//             value={formData.reference || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Explanation"
//             name="explanation"
//             value={formData.explanation || ""}
//             onChange={handleChange}
//             multiline
//             rows={4}
//             fullWidth
//             margin="dense"
//           />

//           <TextField
//             label="Model"
//             name="model"
//             value={formData.model || ""}
//             onChange={handleChange}
//             fullWidth
//             margin="dense"
//           />

//         </DialogContent>

//         <DialogActions>
//           <Button onClick={closeDialogs}>Cancel</Button>
//           <Button onClick={handleUpdate}>Save</Button>
//         </DialogActions>
//       </Dialog>

//       {/* ================= DELETE ================= */}
//       <Dialog open={openDelete} onClose={closeDialogs}>
//         <DialogTitle>Delete Explanation</DialogTitle>
//         <DialogContent>
//           Delete <b>{selected?.reference}</b> ?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeDialogs}>Cancel</Button>
//           <Button color="error" onClick={handleDelete}>Delete</Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default DisplayExplanations;


import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, Paper, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, Typography, Box
} from "@mui/material";

const DisplayExplanations = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [search, setSearch] = useState(""); // ✅ NEW

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selected, setSelected] = useState(null);
  const [formData, setFormData] = useState({});

  // ================= FETCH =================
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetch(`${API_URL}/v1/explanations`);
      const result = await res.json();
      setData(result.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  // ================= SEARCH =================
  const handleSearch = async (value) => {
    setSearch(value);

    if (!value.trim()) {
      fetchData(); // fallback
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/v1/explanations/search?q=${encodeURIComponent(value)}`
      );
      const result = await res.json();

      setData(result.data || []);
      setPage(0); // reset page
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  // ================= PAGINATION =================
  const handlePageChange = (_, newPage) => setPage(newPage);

  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  // ================= DIALOGS =================
  const openDetailsDialog = (row) => {
    setSelected(row);
    setOpenDetails(true);
  };

  const openEditDialog = (row) => {
    setSelected(row);
    setFormData({
      verseId: row.verseId,
      reference: row.reference,
      explanation: row.explanation,
      model: row.model,
    });
    setOpenEdit(true);
  };

  const openDeleteDialog = (row) => {
    setSelected(row);
    setOpenDelete(true);
  };

  const closeDialogs = () => {
    setOpenDetails(false);
    setOpenEdit(false);
    setOpenDelete(false);
    setSelected(null);
    setFormData({});
  };

  // ================= INPUT =================
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ================= UPDATE =================
  const handleUpdate = async () => {
    try {
      const res = await fetch(`${API_URL}/v1/explanations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        fetchData();
      }
    } catch (err) {
      console.error(err);
    } finally {
      closeDialogs();
    }
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    try {
      await fetch(`${API_URL}/v1/explanations/${encodeURIComponent(selected.verseId)}`, {
        method: "DELETE",
      });

      setData((prev) =>
        prev.filter((d) => d.verseId !== selected.verseId)
      );
    } catch (err) {
      console.error(err);
    } finally {
      closeDialogs();
    }
  };

  return (
    <>
      {/* ================= SEARCH INPUT ================= */}
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Search explanation..."
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
          fullWidth
        />
      </Box>

      {/* ================= TABLE ================= */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Verse ID</TableCell>
              <TableCell>Reference</TableCell>
              <TableCell>Model</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.verseId}>
                  <TableCell>{row.verseId}</TableCell>
                  <TableCell>{row.reference}</TableCell>
                  <TableCell>{row.model}</TableCell>
                  <TableCell>{row.created_at}</TableCell>

                  <TableCell sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Button size="small" onClick={() => openEditDialog(row)}>Edit</Button>
                    <Button size="small" color="error" onClick={() => openDeleteDialog(row)}>Delete</Button>
                    <Button size="small" variant="outlined" onClick={() => openDetailsDialog(row)}>View</Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={data.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsChange}
        />
      </TableContainer>

      {/* dialogs unchanged */}
      {/* DETAILS */}
      <Dialog open={openDetails} onClose={closeDialogs}>
        <DialogTitle>Explanation Details</DialogTitle>
        <DialogContent>
          <Typography><b>Verse:</b> {selected?.verseId}</Typography>
          <Typography><b>Reference:</b> {selected?.reference}</Typography>
          <Typography><b>Explanation:</b> {selected?.explanation}</Typography>
          <Typography><b>Model:</b> {selected?.model}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialogs}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* EDIT */}
      <Dialog open={openEdit} onClose={closeDialogs}>
        <DialogTitle>Edit Explanation</DialogTitle>
        <DialogContent>
          <TextField label="Verse ID" name="verseId" value={formData.verseId || ""} onChange={handleChange} fullWidth margin="dense" />
          <TextField label="Reference" name="reference" value={formData.reference || ""} onChange={handleChange} fullWidth margin="dense" />
          <TextField label="Explanation" name="explanation" value={formData.explanation || ""} onChange={handleChange} multiline rows={4} fullWidth margin="dense" />
          <TextField label="Model" name="model" value={formData.model || ""} onChange={handleChange} fullWidth margin="dense" />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialogs}>Cancel</Button>
          <Button onClick={handleUpdate}>Save</Button>
        </DialogActions>
      </Dialog>

      {/* DELETE */}
      <Dialog open={openDelete} onClose={closeDialogs}>
        <DialogTitle>Delete Explanation</DialogTitle>
        <DialogContent>
          Delete <b>{selected?.reference}</b> ?
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialogs}>Cancel</Button>
          <Button color="error" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayExplanations;